"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Button = exports.BUTTON_SIZES = void 0;
var react_1 = __importDefault(require("react"));
var Icon_1 = require("./Icon");
var styled_components_1 = __importDefault(require("styled-components"));
var accessors_1 = require("../themes/accessors");
var layout_1 = require("../themes/layout");
exports.BUTTON_SIZES = ['md', 'sm', 'lg'];
var StyledLabel = styled_components_1.default.span(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  color: inherit;\n  font-size: inherit;\n  line-height: inherit;\n  flex-grow: 1;\n"], ["\n  color: inherit;\n  font-size: inherit;\n  line-height: inherit;\n  flex-grow: 1;\n"])));
var buttonBackground = function (props) {
    if (props.appearance !== 'solid') {
        return 'transparent';
    }
    return accessors_1.color(props.color, 'base')(props);
};
var buttonTextColor = function (props) {
    if (props.appearance === 'solid') {
        return accessors_1.textColor('contrast')(props);
    }
    return accessors_1.textColor(props.color)(props);
};
var StyledButton = styled_components_1.default('button')(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  border-style: solid;\n  border-width: ", "px;\n  border-radius: ", "px;\n  border-color: ", ";\n  padding: ", "px\n  ", "px;\n  background-color: ", ";\n  color: ", ";\n  fill: currentColor;\n  font-size: ", "px;\n  // shouldn't set line-height to px but in this case I want to match\n  // the icon size so the button is the same height with or without icon.\n  line-height: ", "px;\n  font-family: ", ";\n  cursor: ", ";\n"], ["\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  border-style: solid;\n  border-width: ",
    "px;\n  border-radius: ",
    "px;\n  border-color: ",
    ";\n  padding: ",
    "px\n  ",
    "px;\n  background-color: ", ";\n  color: ", ";\n  fill: currentColor;\n  font-size: ",
    "px;\n  // shouldn't set line-height to px but in this case I want to match\n  // the icon size so the button is the same height with or without icon.\n  line-height: ",
    "px;\n  font-family: ", ";\n  cursor: ", ";\n"])), function (props) { return props.size === 'sm'
    ? accessors_1.borderWidth('sm')
    : accessors_1.borderWidth('md'); }, function (props) { return props.size === 'sm'
    ? accessors_1.borderRadius('sm')
    : accessors_1.borderRadius('md'); }, function (props) { return props.appearance === 'outline'
    ? 'currentColor'
    : 'transparent'; }, function (props) { return props.size === 'sm'
    ? accessors_1.space('xs')
    : accessors_1.space('sm'); }, function (props) { return props.size === 'sm'
    ? accessors_1.space('sm')
    : accessors_1.space('xxl'); }, buttonBackground, buttonTextColor, function (props) { return props.size === 'sm'
    ? accessors_1.fontSize('caption')
    : accessors_1.fontSize('base'); }, function (props) { return props.size === 'sm'
    ? layout_1.ICON_SIZES.xs
    : layout_1.ICON_SIZES.sm; }, accessors_1.fontFamily('sansSerif'), function (props) { return props.disabled ? 'default' : 'pointer'; });
var StyledButtonIcon = styled_components_1.default(StyledButton)(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  flex-shrink: 0;\n  padding: ", "px;\n"], ["\n  flex-shrink: 0;\n  padding: ",
    "px;\n"])), function (props) { return props.size === 'sm'
    ? accessors_1.space('xs')
    : accessors_1.space('sm'); });
var StyledButtonIconAfter = styled_components_1.default(StyledButton)(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n  padding-right: ", "px;\n  padding-left: ", "px;\n\n  ", " {\n    margin-right: ", "px;\n  }\n"], ["\n  padding-right: ",
    "px;\n  padding-left: ",
    "px;\n\n  ", " {\n    margin-right: ",
    "px;\n  }\n"])), function (props) { return props.size === 'sm'
    ? null
    : accessors_1.space('xl'); }, function (props) { return props.size === 'sm'
    ? accessors_1.space('lg')
    : null; }, StyledLabel, function (props) { return props.size === 'sm'
    ? accessors_1.space('sm')
    : accessors_1.space('lg'); });
var StyledButtonIconBefore = styled_components_1.default(StyledButton)(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n  flex-direction: row-reverse;\n  padding-right: ", "px;\n  padding-left: ", "px;\n\n  ", " {\n    margin-left: ", "px;\n  }\n"], ["\n  flex-direction: row-reverse;\n  padding-right: ",
    "px;\n  padding-left: ",
    "px;\n\n  ", " {\n    margin-left: ",
    "px;\n  }\n"])), function (props) { return props.size === 'sm'
    ? accessors_1.space('lg')
    : null; }, function (props) { return props.size === 'sm'
    ? null
    : accessors_1.space('xl'); }, StyledLabel, function (props) { return props.size === 'sm'
    ? accessors_1.space('sm')
    : accessors_1.space('lg'); });
var Button = function (_a) {
    var label = _a.label, _b = _a.color, color = _b === void 0 ? 'main' : _b, _c = _a.iconName, iconName = _c === void 0 ? null : _c, _d = _a.iconPosition, iconPosition = _d === void 0 ? 'after' : _d, _e = _a.type, type = _e === void 0 ? 'button' : _e, _f = _a.size, size = _f === void 0 ? exports.BUTTON_SIZES[0] : _f, _g = _a.appearance, appearance = _g === void 0 ? 'solid' : _g, iconSize = _a.iconSize, otherProps = __rest(_a, ["label", "color", "iconName", "iconPosition", "type", "size", "appearance", "iconSize"]);
    iconSize = iconSize || (size === 'sm' ? 'xs' : 'sm');
    if (!iconName && !label) {
        console.error('your button must have at least an icon or a label');
    }
    if (iconName && !label) {
        return react_1.default.createElement(StyledButtonIcon, __assign({ appearance: appearance, type: type, size: size, color: color }, otherProps),
            react_1.default.createElement(Icon_1.Icon, { name: iconName, size: iconSize }));
    }
    if (iconName && iconPosition === 'after') {
        return react_1.default.createElement(StyledButtonIconAfter, __assign({ appearance: appearance, type: type, size: size, color: color }, otherProps),
            react_1.default.createElement(StyledLabel, null, label),
            react_1.default.createElement(Icon_1.Icon, { name: iconName, size: iconSize }));
    }
    if (iconName && iconPosition === 'before') {
        return react_1.default.createElement(StyledButtonIconBefore, __assign({ appearance: appearance, type: type, size: size, color: color }, otherProps),
            react_1.default.createElement(StyledLabel, null, label),
            react_1.default.createElement(Icon_1.Icon, { name: iconName, size: iconSize }));
    }
    return react_1.default.createElement(StyledButton, __assign({ appearance: appearance, type: type, size: size, color: color }, otherProps),
        react_1.default.createElement(StyledLabel, null, label));
};
exports.Button = Button;
exports.default = exports.Button;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5;
